import React, { memo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchVersions,
  getVersionsSortedDesc,
  areVersionsLoading,
} from "../../../../store/slices/missions";
import { Spinner } from "../../../Spinner/Spinner";
import { parseTime } from "../../../LiveMissionsTable/utils";
import {
  VersionHistoryWrapper,
  VersionHistoryTitle,
  VersionTable,
  VersionTableHead,
  VersionTableHeaderRow,
  VersionTableHeader,
  VersionTableBody,
  VersionTableRow,
  VersionTableCell,
  VersionNumber,
  EmptyState,
  LoadingContainer,
} from "./styles";

export interface VersionHistoryProps {
  masterId: string;
}

export const VersionHistory = memo<VersionHistoryProps>(({ masterId }) => {
  const dispatch = useDispatch();

  // Call selector factories with masterId to get the actual selectors
  const versions = useSelector(getVersionsSortedDesc(masterId));
  const loading = useSelector(areVersionsLoading(masterId));

  useEffect(() => {
    // Dispatch the async thunk
    dispatch(fetchVersions(masterId) as any);
  }, [masterId, dispatch]);

  if (loading) {
    return (
      <LoadingContainer>
        <Spinner color="#1b1b1b" />
      </LoadingContainer>
    );
  }

  if (!versions || versions.length === 0) {
    return <EmptyState>No versions found</EmptyState>;
  }

  return (
    <VersionHistoryWrapper>
      <VersionHistoryTitle>Version History</VersionHistoryTitle>
      <VersionTable>
        <VersionTableHead>
          <VersionTableHeaderRow>
            <VersionTableHeader>Version</VersionTableHeader>
            <VersionTableHeader>Created</VersionTableHeader>
            <VersionTableHeader>Created By</VersionTableHeader>
          </VersionTableHeaderRow>
        </VersionTableHead>
        <VersionTableBody>
          {versions.map((version) => (
            <VersionTableRow key={version.id}>
              <VersionTableCell>
                <VersionNumber>
                  v{(version as any).versionNumber ?? version.version_number}
                </VersionNumber>
              </VersionTableCell>
              <VersionTableCell>
                {parseTime((version as any).updatedAt ?? version.updated_at)}
              </VersionTableCell>
              <VersionTableCell>
                {(version as any).createdBy ??
                  (version as any).created_by ??
                  "—"}
              </VersionTableCell>
            </VersionTableRow>
          ))}
        </VersionTableBody>
      </VersionTable>
    </VersionHistoryWrapper>
  );
});

VersionHistory.displayName = "VersionHistory";
